export const retriveMotivoSubmotivoOptions = (queryMotivo, querySubmotivo, motivos, isLoading) => {
  if (isLoading) {
    return { selectedMotivo: "", selectedSubmotivo: "", motivosOptions: [], submotivosOptions: [] };
  }

  const selectedSubmotivo = parseInt(querySubmotivo, 10);

  // si hay un submotivo seleccionado, pero no un motivo,
  // pongo como seleccionada el motivo de ese Submotivo
  const selectedMotivo =
    selectedSubmotivo && !queryMotivo
      ? motivos.find((motivo) => motivo.Submotivos.map((submotivo) => submotivo.itemId).includes(selectedSubmotivo)).itemId
      : parseInt(queryMotivo, 10);

  const existentIds = [];
  const submotivos = motivos
    .filter((motivo) => !queryMotivo || motivo.itemId === selectedMotivo)
    .reduce((submotivosList, motivo) => submotivosList.concat(motivo.Submotivos), [])
    // Filtro duplicados
    .filter((submotivo) => {
      if (submotivo === null || existentIds.includes(submotivo.itemId)) {
        return false;
      }
      existentIds.push(submotivo.itemId);
      return true;
    });

  // Transformo el objeto motivos a atributos de options
  const motivosOptions = motivos
    .map((motivo) => {
      return { label: motivo.titulo, value: motivo.itemId };
    })
    .sort((a, b) => (a.label > b.label ? 1 : -1));

  const submotivosOptions = submotivos
    .map((item) => {
      return { label: item.title, value: item.itemId };
    })
    .sort((a, b) => (a.label > b.label ? 1 : -1));

  return { selectedMotivo, selectedSubmotivo, motivosOptions, submotivosOptions };
};
